import { DashboardRouter } from '../dashboard.router';

export class RegionsRouter {
    static getRoute(): string {
        return `${DashboardRouter.getRoute()}/regions`;
    }
}
